"use client";
import React, { useEffect, useState } from "react";

const breakpoints = [
  { name: "XS", className: "sm:hidden" },
  { name: "SM", className: "hidden sm:inline md:hidden" },
  { name: "MD", className: "hidden md:inline lg:hidden" },
  { name: "LG", className: "hidden lg:inline xl:hidden" },
  { name: "XL", className: "hidden xl:inline 2xl:hidden" },
  { name: "2XL", className: "hidden 2xl:inline" },
];

const TailwindDev: React.FC = () => {
  const [width, setWidth] = useState<number>(0);
  const [height, setHeight] = useState<number>(0);

  useEffect(() => {
    const update = () => {
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
    };
    update();
    if (process.env.NODE_ENV === "development") {
      window.addEventListener("resize", update);
      return () => window.removeEventListener("resize", update);
    }
  }, []);

  if (process.env.NODE_ENV !== "development") return null;

  return (
    <div className="fixed bottom-5 left-20 z-[999] flex items-center space-x-2 rounded-full bg-black px-2.5 py-1 font-mono text-xs font-medium text-white">
      <span>{`${width.toLocaleString()} x ${height.toLocaleString()}`}</span>
      <div className="h-4 w-px bg-gray-800" />
      {breakpoints.map((bp) => (
        <span key={bp.name} className={bp.className}>
          {bp.name}
        </span>
      ))}
    </div>
  );
};

export default TailwindDev;
